import { render, staticRenderFns } from "./name-input.vue?vue&type=template&id=43f1a1a6"
import script from "./name-input.ts?vue&type=script&lang=js&external"
export * from "./name-input.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports